import React from 'react';


export default function  PrivacyPolicypartners () {
  return (
    <div className=" min-h-screen">
      {/* Navbar */}
      <nav className="top-0 w-full z-10 shadow-lg"
      style={{ backgroundColor: "#212529" }}
      >
        <div className="container mx-auto flex justify-center items-center">
          {/* Logo */}
          <a href="#">
            <img src="images/surpeats-logo.svg" alt="Surpeats Logo" className="h-3/4" />
          </a>
        </div>
      </nav>

      <div className="container mx-auto px-4 py-4">
        <h1 className="text-4xl font-bold text-gray-800 mb-4">Privacy Policy for Surpeats Partners App</h1>
        <h3 className="text-xl font-semibold text-gray-700 mb-6">Effective Date: 26th November 2024</h3>
        <p className="text-gray-700 mb-6">
          Surpeats (“we,” “our,” or “us”) values your privacy and is committed to safeguarding the
          personal and business information of our partners, including restaurants, cafes, and stores
          (“you” or “partners”). This Privacy Policy explains how we collect, use, and protect your
          information when you use the Surpeats Partners App (the “App”).
          <br />
          <br />
          By using the App, you consent to the collection, processing, and sharing of your information
          as described in this Privacy Policy, in compliance with the Digital Personal Data Protection
          Act (DPDPA), 2023, and other applicable laws in India.
        </p>

        <h2 className="text-2xl font-bold text-gray-800 mb-4">1. Information We Collect</h2>
        <h3 className="text-lg font-semibold text-gray-700 mb-2">a. Business Information</h3>
        <p className="text-gray-700 mb-4">
          When you register and use the App, we collect: <br />
          • Business name, address, and contact details <br />
          • Business registration information (e.g., GSTIN, FSSAI license) <br />
          • Bank account details for payouts <br />
          • Tax-related identifiers (e.g., PAN)
        </p>

        <h3 className="text-lg font-semibold text-gray-700 mb-2">b. App Usage Data</h3>
        <p className="text-gray-700 mb-4">
          We collect operational data, such as: <br />
          • Orders received and processed <br />
          • Inventory or surplus food details <br />
          • Revenue, commission, and payout history
        </p>

        <h3 className="text-lg font-semibold text-gray-700 mb-2">c. Technical and Device Information</h3>
        <p className="text-gray-700 mb-4">
          We automatically collect technical data, including: <br />
          • Device type, operating system, and unique identifiers <br />
          • IP address and login activity
        </p>

        <h3 className="text-lg font-semibold text-gray-700 mb-2">d. Location Data</h3>
        <p className="text-gray-700 mb-4">
          With your consent, we collect your location to enable discovery of your business by nearby
          users.
        </p>

        <h3 className="text-lg font-semibold text-gray-700 mb-2">e. Use of Camera</h3>
        <p className="text-gray-700 mb-4">
          Surpeats may request access to your device’s camera to enhance your experience with the
          platform. The camera may be used for the following purposes:
          <br />
          • Capturing Images of Food Offerings: To upload images of the mystery bags or food items being
          sold. <br />
          • Verification: For capturing documents or images required for account setup or compliance
          purposes.
        </p>

        <h2 className="text-2xl font-bold text-gray-800 mb-4">2. Legal Basis for Processing</h2>
        <p className="text-gray-700 mb-4">
          Under the Digital Personal Data Protection Act, 2023 (DPDPA), we process your information
          based on the following grounds: <br />
          • Consent: For optional features like location tracking and promotional communications. <br />
          • Performance of Contract: To provide our services to you. <br />
          • Legal Obligations: To comply with applicable laws, tax regulations, and government reporting
          requirements. <br />
          • Legitimate Interests: To enhance the functionality, security, and efficiency of the App.<br />
          You may withdraw your consent at any time for data collected on a consent basis, but doing so may affect your ability to use certain features.
        </p>
        <h2 className="text-2xl font-bold text-gray-800 mb-4">3. How We Use Your Information</h2>
        <p className="text-gray-700 mb-4">
          We use your information for the following purposes: <br />
          • Facilitating registration, onboarding, and account management. <br />
          • Connecting your business with customers on the Surpeats platform. <br />
          • Processing payouts and maintaining financial records. <br />
          • Sending notifications about orders, payments, and updates. <br />
          • Monitoring compliance with legal and operational guidelines. <br />
          • Improving the App’s functionality and user experience.
        </p>

        <h2 className="text-2xl font-bold text-gray-800 mb-4">4. Sharing Your Information</h2>
        <p className="text-gray-700 mb-4">
          We only share your information as necessary, in compliance with the DPDPA: <br />
          • With Users: Basic business information (e.g., name, location, and food
          offerings) is visible to users to facilitate transactions. <br />
          • With Service Providers: Third-party vendors such as payment processors,
          cloud storage providers, and technical support teams. <br />
          • With Authorities: To comply with legal, regulatory, or tax requirements or in
          response to lawful government requests. <br />
          • Business Transfers: If we undergo a merger, acquisition, or sale, your data
          may be transferred as part of our assets. <br />
          We do not sell or rent your personal or business information to third parties.
        </p>

        <h2 className="text-2xl font-bold text-gray-800 mb-4">5. Data Security</h2>
        <p className="text-gray-700 mb-4">
          We implement robust security measures, including: <br />
          • Encryption of sensitive information (e.g., payment and tax details). <br />
          • Restricted access to data, limited to authorized personnel. <br />
          • Regular audits and security updates to prevent unauthorized access. <br />
          While we strive to protect your information, no system is completely secure. You are
          responsible for maintaining the confidentiality of your login credentials.
        </p>

        <h2 className="text-2xl font-bold text-gray-800 mb-4">6. Your Rights Under DPDPA</h2>
        <p className="text-gray-700 mb-4">
          As a partner, you have the following rights under the Digital Personal Data Protection Act,
          2023: <br />
          • Right to Access and Correction: You can request access to or correction of
          your data stored with us. <br />
          • Right to Erasure: You can request deletion of your personal data, subject to
          legal or regulatory retention requirements. <br />
          • Right to Data Portability: Request your data in a portable format where
          applicable. <br />
          • Right to Grievance Redressal: Raise concerns if you believe your data rights
          are violated. <br />
          To exercise these rights, contact us using the details below.
        </p>

        <h2 className="text-2xl font-bold text-gray-800 mb-4">7. Data Retention</h2>
        <p className="text-gray-700 mb-4">
          We retain your information as long as your account is active and for as long as required by
          applicable laws (e.g., for tax and compliance purposes). Once retention periods are over, we
          securely delete your data.
        </p>

        <h2 className="text-2xl font-bold text-gray-800 mb-4">8. Compliance with Indian Laws</h2>
        <p className="text-gray-700 mb-4">
          This Privacy Policy complies with Indian data protection and privacy laws, including: <br />
          • Digital Personal Data Protection Act, 2023 (DPDPA): Governing the
          collection, use, and storage of personal data in India. <br />
          • Information Technology Act, 2000: Adherence to rules for sensitive personal
          data or information (SPDI). <br />
          • Tax Regulations: Compliance with GST and PAN-related reporting
          requirements.
        </p>

        <h2 className="text-2xl font-bold text-gray-800 mb-4">9. Changes to This Privacy Policy</h2>
        <p className="text-gray-700 mb-4">
          We may update this Privacy Policy periodically to reflect changes in our practices, the law, or
          regulatory requirements. We will notify you of significant updates through the App or via
          email.
        </p>

        <h2 className="text-2xl font-bold text-gray-800 mb-4">10. Contact Us</h2>
        <p className="text-gray-700 mb-4">
          For questions, concerns, or to exercise your rights under DPDPA, please contact us: <br />
          Email: admin@surpeats.com
        </p>
      </div>

      {/* Footer */}
      <footer className=" text-white py-8"
      style={{ backgroundColor: "#212529" }}
      >
        <div className="container mx-auto text-center">
          <img src="images/surpeats-logo.svg" alt="Surpeats Logo" className="mx-auto h-32" />
          <p>&copy; 2024 Surpeats. All rights reserved.</p>
        </div>
      </footer>
    </div>
  );
};
